import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-button-loading',
  templateUrl: './button-loading.component.html',
  styleUrls: ['./button-loading.component.scss'],
})
export class ButtonLoadingComponent implements OnInit {
  @Input('loading') loading: boolean;
  @Input('disabled') disabled = false;
  @Input('btnClass') btnClass: string;
  @Input('raised') raised = true;
  @Input('loadingText') loadingText = 'Please wait';
  @Input('type') type: 'button' | 'submit' = 'submit';
  @Input('color') color: 'primary' | 'accent' | 'warn';

  constructor() {}

  ngOnInit() {}
}
